"use client";

import { useUser } from "@clerk/nextjs";
import { IconUserCircle } from "@tabler/icons-react";
import { useTranslations } from "next-intl";
import { buttonVariants } from "@/components/ui/button";
import { Skeleton } from "@/components/ui/skeleton";
import { Link } from "@/i18n/navigation";
import { UserAvatar } from "@/components/header/user-avatar";
import { cn } from "@/lib/utils";
import type { HeaderThemeType } from "@/types/common.types";

export const HeaderAccountMobile = ({
  theme,
  hideSignIn = false,
}: {
  theme?: HeaderThemeType;
  hideSignIn?: boolean;
}) => {
  const t = useTranslations("header");
  const { isLoaded, isSignedIn, user } = useUser();
  const isLightHeader = theme === "light" || theme === "all-light";

  if (!isLoaded) {
    return <Skeleton className="size-7 rounded-full" />;
  }

  if (isSignedIn) {
    return (
      <Link
        aria-label={t("panel")}
        data-pw="mobile-account-button"
        href="/panel/diets"
      >
        <UserAvatar
          className="size-7"
          compact
          variant={isLightHeader ? "dark" : "light"}
        />
      </Link>
    );
  }

  if (hideSignIn) {
    return null;
  }

  return (
    <Link
      aria-label={t("signIn")}
      className={cn(
        buttonVariants({ variant: "ghost", size: "icon" }),
        "h-10 transition-none"
      )}
      data-pw="mobile-sign-in-button"
      href={{ pathname: "/sign-in/[[...sign-in]]", params: { "sign-in": [] } }}
    >
      <IconUserCircle
        className={cn(
          "size-7",
          (theme === "light" || theme === "all-light") && "text-primary"
        )}
        stroke={1.5}
      />
    </Link>
  );
};
